import {ChangeEvent, Dispatch, SetStateAction, useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import DotsLoading from '../../../../components/dotsLoading';
import CustomCheckbox from '../../../../components/mazraeKit/customCheckbox';
import usePatchDirectLoanRequest from '../../../../services/hookService/patchDirectLoanRequest/usePatchDirectLoanRequest';
import usePatchLoanRequest from '../../../../services/hookService/patchLoanRequest/usePatchLoanRequest';
import {LoanRequestStatus} from '../../../myAccount/my-credits/consts/loanStatus';
import {useMultiStepForm} from '../useMultiStepForm';

interface IProps {
  isOpenSubmitBtm: boolean;
  setIsOpenSubmitBtm: Dispatch<SetStateAction<boolean>>;
  selectedLoan: ILoanType | null;
  loanRequestGuid: string;
  isDirectLoan: boolean;
}

const SubmitLoanBtmSheet = (props: IProps) => {
  const {goNext} = useMultiStepForm();

  const {
    isOpenSubmitBtm,
    setIsOpenSubmitBtm,
    selectedLoan,
    loanRequestGuid,
    isDirectLoan,
  } = props;
  const [isAgree, setIsAgree] = useState(false);

  const rules = selectedLoan?.loan_rules
    .map(rule => rule.description)
    .map(desc => desc.split('\r\n'))
    .flat();

  const {mutate: mutatePatchLoan, isLoading: isLoadingPatchLoan} =
    usePatchLoanRequest();

  const {mutate: mutatePatchDirectLoan, isLoading: isLoadingPatchDirectLoan} =
    usePatchDirectLoanRequest();

  const handleSubmit = () => {
    const payload: IPatchLoanRequestPayload | IPatchDirectLoanRequestPayload = {
      loan_request_guid: loanRequestGuid,
      loan_type: selectedLoan?.guid,
      // removed since the bank validation is not ready or is never going to be ready
      // status: isDirectLoan ? 6 : 5,
      status: isDirectLoan ? 6 : LoanRequestStatus.FILLING_DOCUMENT,
    };

    if (isDirectLoan) {
      if (isAgree && loanRequestGuid && selectedLoan) {
        mutatePatchDirectLoan(payload, {onSuccess: () => goNext(isDirectLoan)});
      }
    } else {
      if (isAgree && loanRequestGuid && selectedLoan) {
        mutatePatchLoan(payload, {onSuccess: () => goNext(isDirectLoan)});
      }
    }
  };

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    setIsAgree(e.target.checked);
  };

  return (
    <BottomSheet
      onDismiss={() => setIsOpenSubmitBtm(false)}
      open={isOpenSubmitBtm}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-6 left-6"
          onClick={() => setIsOpenSubmitBtm(false)}
        />

        <div className="flex flex-col items-center justify-center gap-2">
          <p className="flex justify-center text-lg font-bold text-gray-950">
            شرایط دریافت وام
          </p>
        </div>

        {rules &&
          rules?.length > 0 &&
          rules.map((item, index) => (
            <div key={index} className="flex items-center gap-1 text-sm">
              <div className="block w-[6px] h-[6px] bg-gray-500 rounded-full" />
              <span>{item}</span>
            </div>
          ))}

        <div className="w-full h-[1px] bg-gray-200 my-2" />

        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <CustomCheckbox checked={isAgree} onChange={handleCheckboxChange} />
          <span>همه شرایط گفته شده بالا را دارم</span>
        </label>

        <div className="flex justify-end w-full px-3 mt-4">
          <button
            type="button"
            className="w-full px-3 py-2 mt-1 text-white rounded-lg bg-farm-shop-500 text-md disabled:bg-gray-500"
            disabled={!isAgree}
            onClick={() => handleSubmit()}
          >
            {isLoadingPatchLoan || isLoadingPatchDirectLoan ? (
              <DotsLoading />
            ) : (
              'ادامه'
            )}
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default SubmitLoanBtmSheet;
